import { useEffect, useRef, useState } from 'react';
import { useI18n } from '@i18n/useI18n';
import { Space, Wrapper } from './Secretary.styled';
import moment from 'moment';
import { useStore } from '@store/appStore';
import db from '@utils/db';
import { useAuthentication } from '@providers/AuthProvider';
import Profile from '@components/Profile';
import Course from '@components/Course';
import RainbowLoader from '@components/Loaders/RainbowLoader';
import { useStyleStore } from '@store/styleStore';
import SubNav from '@components/SchoolLeader/SubNav';
import StatisticsDetails from '@components/SchoolLeader/StatisticsDetails';
import ApprovalDetails from '@components/SchoolLeader/ApprovalDetails';
import NoteDetails from '@components/SchoolLeader/NoteDetails';
import RegistrationDetails from '@components/SchoolLeader/RegistrationDetails';
import CourseDetails from '@components/SchoolLeader/CourseDetails';
import StudentDetails from '@components/SchoolLeader/StudentDetails';
import Dashboard from '@components/SchoolLeader/Dashboard';
import SickDetails from '@components/SchoolLeader/SickDetails';
import FilterNav from '@components/SchoolLeader/FilterNav';

interface IProps { 
  
}

export const Secretary = (props: IProps) => {
  const { client,
    schoolLeaderView,
    filterDate,
    settings,
    selectedSchoolViewSearch,
    setAdminStudentList,
    adminStudentList,
    setSchoolViewTags,
    setSchoolViewStudents,
    setSchoolViewRegistrations,
    setSchoolViewCourses,
    setSchoolViewNotes,
    setSchoolViewApprovals, setSelectedSchoolViewSearch, setSchoolLeaderView,systemSettings, activeFilter, setFilterWarning, setActiveFilter, semesters, setFilterDate } = useStore();
  const { setFloatingNavHeight } = useStyleStore();
  const [total, setTotal] = useState(null);  
  const [day, setDay] = useState(null);
  const [noteInfo, setNoteInfo] = useState(null);
  const { getId, getType } = useAuthentication();
  const studentId = useRef(null)
  const courseId = useRef(null)
  const [loading, setLoading] = useState(false)
  const [filterSelected, setFilterSelected] = useState(false)
  useEffect(() => {
    getTags()
    setFloatingNavHeight(0)
    handleFilter()
  }, [activeFilter])

  const handleFilter = () => {    
      if(activeFilter === 0)
      {      
        setFilterWarning(false);
        setActiveFilter(semesters.length - 1);
        let singleSemester = semesters[semesters.length - 1];
        setFilterDate(singleSemester.text, singleSemester.year, singleSemester.fromDate, moment(singleSemester.toDate).isAfter(moment().format('YYYY-MM-DD')) ? moment().format('YYYY-MM-DD') : singleSemester.toDate, singleSemester.toDate);
        sessionStorage.setItem('dateFilter', JSON.stringify({ index: semesters.length -1, text: singleSemester.text, year: singleSemester.year, from: singleSemester.fromDate, to: singleSemester.toDate, isDateFilter: true, enddate: singleSemester.toDate }));
      }
      else
      {
        setFilterSelected(true)
      }
    }


  const getTags = async () => {
    let allTags = await db.getAllNote_Tags();
    setSchoolViewTags(allTags);
  }

  useEffect(() => {
    if (selectedSchoolViewSearch?.type === "STUDENT") getData(selectedSchoolViewSearch?.username, selectedSchoolViewSearch?.id)
    else if (selectedSchoolViewSearch?.type === "COURSE") getStudents(selectedSchoolViewSearch?.id)
    else clearData()
  }, [selectedSchoolViewSearch])

  const clearData = () => {
    setTotal(null);
    setDay(null);
    setNoteInfo(null);
    setAdminStudentList(null)
    studentId.current = null
    courseId.current = null
  }


  async function getData(username, id, force?) {
    if (studentId.current === id || force) return
    setTotal(null);
    setDay(null);
    setNoteInfo(null);
    if (id === null) return

    studentId.current = id

    const note = await db.GetNoteCounts4Student(id, client.UserName, getType());
    if (note && note.length > 0) setNoteInfo(note[0]);
    const totalData = await db.Student_Stat_GetTotalPercentage(username, filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE);
    const totalabsence = totalData ? totalData[0] : null;

    if (settings.USENOTFULLBLOCKPAUSE) {
      db.GetPause4Students(JSON.stringify([{ student_id: id }]), filterDate.from, filterDate.to).then(r => {
        if (r.length > 0) {
          //@ts-ignore
          totalabsence.secondabsence = totalabsence.secondabsence - r[0].pause_absence_length
          //@ts-ignore
          totalabsence.secondcount = totalabsence.secondcount - r[0].pause_length
          //@ts-ignore
          totalabsence.merit = true
        }
        setTotal(totalabsence);
      })
    }
    else {
      setTotal(totalabsence);
    }


    const dayData = await db.Student_Stat_GetTotalPercentageDay(username, filterDate.from, filterDate.to, null, null, settings.USEMERIT, settings.USEPAUSE);
    setDay(dayData);
  }

  async function getStudents(id, force?) {
    if (courseId.current === id || force) return
    let list;
    list = await db.ADM_StudentsPerClass_ID(id, client.UserName, getType(), filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE);
    let c4 = await db.ADM_CoursePercentageOverTime(id, filterDate.from, filterDate.to, settings.USEMERIT, settings.USEPAUSE);
    setDay(c4);
    if (c4.length > 0) {
      let c5 = null
      if (settings.USENOTFULLBLOCKPAUSE) c5 = await db.GetPause4Class(JSON.stringify([{ class_id: id }]), filterDate.from, filterDate.to)
      let percent = c4[c4.length - 1].minutesPercentage

      if (c5?.length > 0) {
        //@ts-ignore
        let duration = c4[c4.length - 1].duration - c5[0].pause_length
        //@ts-ignore
        let absenceDuration = c4[c4.length - 1].absenceduration - c5[0].pause_absence_length
        percent = (absenceDuration / duration) * 100
      }
      setTotal(settings.USE_LESSON_BASED_ABSENCE === 'true' ? c4[c4.length - 1].lessonPercentage : percent);
    }
    else setTotal(null);


    // sort studentlist by total_percentage, highest to lowest
    if (list) {
      list.sort((a, b) => {
        if (a.course_percentage > b.course_percentage) {
          return -1;
        }
        if (a.course_percentage < b.course_percentage) {
          return 1;
        }
        return 0;
      });

      if (settings.USENOTFULLBLOCKPAUSE) {
        //@ts-ignore
        let pauseStudents = await db.GetPause4Students(JSON.stringify(list.map(s => { return { student_id: s.student_sis_id } })), filterDate.from, filterDate.to, selectedSchoolViewSearch.id)
        if (pauseStudents.length > 0) {
          for (let i = 0; i < pauseStudents.length; i++) {
            const p = pauseStudents[i];
            //@ts-ignore
            let student = list.find(s => s.student_sis_id === p.student_id)
            //@ts-ignore
            student.totallength = student.totallength - p.pause_length;
            //@ts-ignore
            student.absenceduration = student.absenceduration - p.pause_absence_length
            //@ts-ignore
            student.merit = true
          }
        }
      }
    }

    setAdminStudentList(list);
  }

  const getStudentsData = async (force?) => {
    !force ? setLoading(true) : null
    let students = await db.GetStudents(filterDate.from, filterDate.to)
    setSchoolViewStudents(students && students.length > 0 ? students : [])
    !force ? setLoading(false) : null
  }

  const refreshData = async () => {
    if (loading) return
    setLoading(true)
    if (selectedSchoolViewSearch?.type === "STUDENT") {
      return Promise.all([getStudentsData(true),
      getCourses(true),
      getRegistrations(true),
      getNotes(true),
      getApprovals(true),
      getData(selectedSchoolViewSearch?.username, selectedSchoolViewSearch?.id)]).then(() => setLoading(false)
      )
    }
    else if (selectedSchoolViewSearch?.type === "COURSE") {
      return Promise.all([getStudentsData(true),
      getCourses(true),
      getRegistrations(true),
      getNotes(true),
      getApprovals(true),
      getStudents(selectedSchoolViewSearch?.id)]).then(() => setLoading(false)
      )
    }
    else {
      return Promise.all([getStudentsData(true),
      getCourses(true),
      getRegistrations(true),
      getNotes(true),
      getApprovals(true)]).then(() => setLoading(false)
      )
    }
  }

  const getRegistrations = async (force?) => {
    !force ? setLoading(true) : null
    let timezone = systemSettings.find((s) => s.APP_Setting_ID === 7);
    let regs = await db.GetAllRegistrations(filterDate.from, filterDate.to, timezone.value, 30)
    setSchoolViewRegistrations(regs && regs.length > 0 ? regs : [])
    !force ? setLoading(false) : null
  }

  const getCourses = async (force?) => {
    !force ? setLoading(true) : null
    let courses = await db.GetCourses(filterDate.from, filterDate.to)
    setSchoolViewCourses(courses && courses.length > 0 ? courses : [])
    !force ? setLoading(false) : null
  }

  const getNotes = async (force?) => {
    !force ? setLoading(true) : null
    let notes = await db.GetNotesForDash(filterDate.from, filterDate.to)
    notes = notes.sort((a, b) => {
      if (a.create_timestamp > b.create_timestamp) return -1
      else if (a.create_timestamp < b.create_timestamp) return 1
      else return 0
    })
    setSchoolViewNotes(notes && notes.length > 0 ? notes : [])
    !force ? setLoading(false) : null
  }

  const getApprovals = async (force?) => {
    !force ? setLoading(true) : null
    let approvals = await db.GetAbsenceRequests4Approval(client.UserName, filterDate.from)
    setSchoolViewApprovals(approvals && approvals.length > 0 ? approvals : [])
    !force ? setLoading(false) : null
  }

  const handleClick = (username, id, displayname, type, sick?) => {
    setSelectedSchoolViewSearch({ username: username, id: id, firstname: username + " - " + displayname, lastname: "", type })
    if (sick) setSchoolLeaderView(7)
  }

  const getView = () => {
    if(filterSelected === false) return <div style={{height: "calc(80vh)"}}><RainbowLoader /></div>
    else if (selectedSchoolViewSearch && selectedSchoolViewSearch.type === "STUDENT" && schoolLeaderView === 7) return loading ? <RainbowLoader /> : <SickDetails />
    else if (selectedSchoolViewSearch && selectedSchoolViewSearch.type === "STUDENT") return loading ? <RainbowLoader /> :
      <>
        <Space />
        <Profile
          id={selectedSchoolViewSearch.username}
          sisId={selectedSchoolViewSearch.id}
          user_id={selectedSchoolViewSearch.id}
          firstname={selectedSchoolViewSearch.firstname}
          lastname={selectedSchoolViewSearch.lastname}
          lastLogin={'client.LASTLOGIN'}
          day={day}
          total={total}
          isAdmin={true}
          schoolView={true}
          notePresent={noteInfo && noteInfo.notePresent}
          noteCount={noteInfo && noteInfo.noteUnreadCount}
        />
      </>
    else if (selectedSchoolViewSearch && selectedSchoolViewSearch.type === "COURSE") return loading ? <RainbowLoader /> :
      <>
        <Space />
        <Course
          students={adminStudentList}
          course={{ percent: total, days: day, id: selectedSchoolViewSearch.id, name: selectedSchoolViewSearch.uni_name, students: adminStudentList }}
        />
      </>
    else if (schoolLeaderView === 0) return <Dashboard secretary={true} handleClick={handleClick} />
    else if (schoolLeaderView === 1) return <StudentDetails secretary={true} handleClick={handleClick} getStudents={getStudentsData} loading={loading} />
    else if (schoolLeaderView === 2) return <CourseDetails getCourses={getCourses} loading={loading} handleClick={handleClick} />
    else if (schoolLeaderView === 3) return <RegistrationDetails getRegistrations={getRegistrations} loading={loading} handleClick={handleClick} />
    else if (schoolLeaderView === 4) return <NoteDetails handleClick={handleClick} getNotes={getNotes} loading={loading} />
    else if (schoolLeaderView === 5) return <ApprovalDetails handleClick={handleClick} getApprovals={getApprovals} loading={loading} />
    else if (schoolLeaderView === 6) return <StatisticsDetails />
  }

  return (<>
    <Wrapper>
      <SubNav secretary={true} refresh={refreshData} loading={loading} />
      <FilterNav filterSelected={filterSelected} />
      {
        getView()
      }
    </Wrapper>
  </>);
};

export default Secretary;
